import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_PETITION_AI_IMAGE_PROMPT_EXPERIMENT = defineFcm(
	'starfish_petition_ai_image_prompt_experiment',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				variants: {
					type: 'record',
					keys: ['control', 'variant1', 'variant2', 'variant3', 'variant4'] as const,
					optionalValues: true,
					shape: {
						type: 'object',
						shape: {
							promptId: { type: 'string', optional: true },
						},
					},
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-middle-end',
		context: 'Petition',
		description: 'A/B testing for OpenAI prompts used in AI Image generation.',
		import: false,
		template: {
			experimentName: '',
			variants: {
				control: {
					promptId: undefined,
				},
				variant1: {
					promptId: undefined,
				},
				variant2: {
					promptId: undefined,
				},
				variant3: {
					promptId: undefined,
				},
				variant4: {
					promptId: undefined,
				},
			},
		},
	});
